import { render, staticRenderFns } from "./ReferralPromotionById.vue?vue&type=template&id=8add5348&"
import script from "./ReferralPromotionById.vue?vue&type=script&lang=js&"
export * from "./ReferralPromotionById.vue?vue&type=script&lang=js&"
import style0 from "./ReferralPromotionById.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports